import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiHeart } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-12 border-t border-gray-800">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center justify-center space-y-6"
        >
          {/* Powered By Section */}
          <div className="flex flex-col items-center space-y-4">
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <span>Powered By</span>
            </div>
            
            <a
              href="https://start.allgrowthco.net/#/engagement-growth-engine"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center space-y-2 transition-all duration-300 hover:scale-105"
            >
              {/* Logo */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-emerald-500/50 transition-shadow duration-300">
                  <span className="text-white font-black text-xl">H</span>
                </div>
                <div className="text-left">
                  <div className="text-xl font-black text-white group-hover:text-emerald-400 transition-colors duration-300">
                    HANDVANTAGE
                  </div>
                  <div className="text-sm font-bold text-emerald-400 group-hover:text-emerald-300 transition-colors duration-300">
                    ALL GROWTH
                  </div>
                </div>
              </div>
            </a>
          </div>

          {/* Divider */}
          <div className="w-full max-w-md h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent"></div>

          {/* Copyright */}
          <div className="flex items-center gap-2 text-gray-500 text-sm">
            <span>© {new Date().getFullYear()} Made with</span>
            <SafeIcon icon={FiHeart} className="text-red-500 fill-current animate-pulse" />
            <span>by HANDVANTAGE</span>
          </div>

          {/* Additional Links (Optional) */}
          <div className="flex items-center gap-6 text-xs text-gray-600">
            <a
              href="https://start.allgrowthco.net/#/engagement-growth-engine"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-emerald-400 transition-colors duration-300"
            >
              Engagement Growth Engine
            </a>
            <span>•</span>
            <a
              href="https://start.allgrowthco.net"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-emerald-400 transition-colors duration-300"
            >
              All Growth Solutions
            </a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;